import Request from './Request';

export interface IMonth {
    id: number;
    name: string;
    order: number;
}

let _allCache: Promise<IMonth[]> | null = null;

export function clearMonthCache() {
    _allCache = null;
}

class Month {
    static GetAll = (): Promise<IMonth[]> => {
        if (!_allCache) {
            _allCache = Request.DoGet('month/all') as unknown as Promise<IMonth[]>;
            _allCache.catch(() => { _allCache = null; });
        }
        return _allCache;
    };
    static Get = (id: Number): IMonth => { return Request.DoGet('month/' + id) as unknown as IMonth; };
}

export default Month;